import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const avatarVariants = cva("therapist-avatar", {
  variants: {
    size: {
      sm: "therapist-avatar-sm",
      md: "therapist-avatar-md",
      lg: "therapist-avatar-lg",
    },
  },
  defaultVariants: { size: "md" },
});

interface TherapistAvatarProps extends VariantProps<typeof avatarVariants> {
  name: string;
  className?: string;
}

export function TherapistAvatar({ name, size, className }: TherapistAvatarProps) {
  const initial = name.trim()[0]?.toUpperCase() ?? "?";
  return (
    <span className={cn(avatarVariants({ size }), className)} aria-label={name}>
      {initial}
    </span>
  );
}
